import React, { useState } from 'react';
import { Card, Stack, Cluster, Text, Button, Icon } from '@iqueue/iq-ui';
import Field from '../ui/Field';

/** A question addressed to the logged-in human, with inline reply. */
export default function HumanRequestCard({ request, onAnswer }) {
  const [answer, setAnswer] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!answer.trim()) return;
    setBusy(true);
    try {
      await onAnswer(request.id, answer.trim());
      setAnswer('');
    } finally { setBusy(false); }
  };

  return (
    <Card variant="outlined">
      <Card.Content>
        <Stack gap={100}>
          <Cluster gap={100} align="center">
            <Icon name="contact_support" size="s" />
            <Text variant="label-medium" render={<span />}>Вопрос вам</Text>
            <Text variant="label-small" muted render={<span />}>от @{request.asked_by || 'системы'}</Text>
          </Cluster>
          <Text variant="body-medium">{request.question}</Text>
          <Cluster gap={100} align="end">
            <Field label="Ваш ответ" value={answer} onChange={setAnswer} multiline rows={2} />
            <Button disabled={busy || !answer.trim()} onClick={submit}>Ответить</Button>
          </Cluster>
        </Stack>
      </Card.Content>
    </Card>
  );
}
